import CoreBase from '../../../../services/engines/CoreBase';
import _service from '../../../../services/UserTopicService';
import responseHelper from '../../../../services/ResponseHelper';

const _name = 'TopicGroupSaver';

/**
 * Handles persisting group settings to the backend.
 */
export default class TopicGroupSaver extends CoreBase {
    _name = _name;

    /**
     * Saves group settings to the backend.
     * @param {object} form
     * @returns {boolean} true if saved successfully, false otherwise
     */
    save = async (form) => {
        try {
            const resp = await _service.saveGroup({ data: form });
            const code = responseHelper.check(resp, 'save', _name);

            if (code > 0) {
                this.onMessage('Group settings saved', 'success');
                return true;
            }

            this.logError('save', `server returned code=${code}, status=${resp?.status}`);
            this.onMessage('Failed to save group settings', 'error');
            return false;
        } catch (error) {
            this.logError('save', error.message);
            this.onError(error.message);
            return false;
        }
    };

    /**
     * Persists active node and entry selection to BE.
     * Called on every entry select — lightweight state sync.
     * @param {OnSelectedEntryData} data - { gid, nid, eid }
     */
    saveActiveEntry = async (data) => {
        try {
            const resp = await _service.saveGroupActivity({ data });
            const code = responseHelper.check(resp, 'saveActiveEntry', _name);
            if (code < 0) {
                this.logError('saveActiveEntry', `code=${code} status=${resp?.status}`);
            }
        } catch (error) {
            this.logError('saveActiveEntry', error.message);
        }
    };
}
